export default {
    viewBox: "0 0 25 24",
    paths: [
      "M10.4285 24V0H3.22852V24H10.4285ZM22.4285 24V0H15.2285V24H22.4285ZM8.80769 1.61928H4.84841V22.3791H8.80769V1.61928ZM16.8486 1.61926H20.8079V22.379H16.8486V1.61926Z",
    ]
  };